module.exports = __webpack_public_path__ + "img/supplier-trade-statistic.49caeb6e.png";